module.exports = __webpack_public_path__ + "img/schets-14.b707b4c7.jpg";